module.exports = __webpack_public_path__ + "img/shangbao.3218d10e.svg";